export default function PageContainer ({ children, className, ...attributes }) {
  return <div {...attributes} className={`max-w-page mx-auto px-8 md:px-32 ${className}`}>
    {children}
  </div>
}